<span *ngIf="disabled">
  <ng-container [ngSwitch]="isObservableValue">
    <div *ngSwitchCase="true">
      <ng-container *ngIf="props.options | formlySelectOptions: field | async as selectOptions">
        {{ getObsValue(selectOptions) }}
      </ng-container>
    </div>
    <div *ngSwitchDefault>{{ renderViewValue() }}</div>
  </ng-container>
</span>

<mat-select
  [class.field-invalid]="showError"
  [compareWith]="compareFn"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [multiple]="props.multiple"
  [placeholder]="props.placeholder || 'Please select'"
  [portalCyTest]="field.key"
  [required]="props.required || false"
  [style.display]="disabled ? 'none' : 'block'"
  class="field-input"
>
  <mat-select-trigger *ngIf="props.displayWith">
    {{ props.displayWith(formControl.value) }}
  </mat-select-trigger>

  <ng-container *ngIf="props.options | formlySelectOptions: field | async as selectOptions">
    <ng-container *ngFor="let item of selectOptions">
      <mat-optgroup
        *ngIf="item.group"
        [label]="item.label"
        class="field-optgroup"
      >
        <mat-option
          *ngFor="let child of item.group"
          [disabled]="child.disabled"
          [value]="child.value"
        >
          {{ child.label }}
        </mat-option>
      </mat-optgroup>
      <mat-option
        *ngIf="!item.group"
        [disabled]="item.disabled"
        [value]="item.value"
      >
        {{ item.label }}
      </mat-option>
    </ng-container>
  </ng-container>
</mat-select>
